import { Information, WarningOrange } from "@assets"
import { WarningRed } from "@assets/icons/WarningRed"
import { AccordeonArrow } from "@atomic/atoms"
import { Colors, Spacing } from "@constants"
import React from "react"
import { StyleSheet, View, Text } from "react-native"
import { TouchableOpacity } from "react-native-gesture-handler"

interface InfoBoxProps {
  type?: "info" | "warning" | "danger"
  collapsible?: boolean
  defaultOpen?: boolean
  title: React.ReactNode | string
  children?: React.ReactNode
}

const typeStyles = {
  warning: {
    backgroundColor: "#FEF3E2",
    borderColor: "#F59E0B",
    icon: <WarningOrange />,
  },
  danger: {
    backgroundColor: "#FEF2F2",
    borderColor: "#EF4444",
    icon: <WarningRed />,
  },
  info: {
    backgroundColor: "#EBF5FF",
    borderColor: "#BFDBFE",
    icon: <Information />,
  },
}

export const InfoBox: React.FC<InfoBoxProps> = ({
  type = "info",
  collapsible = false,
  defaultOpen = true,
  title,
  children,
}) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen)

  const selectedStyle = typeStyles[type]

  return (
    <View
      style={[
        styles.infoBoxContainer,
        {
          backgroundColor: selectedStyle.backgroundColor,
          borderColor: selectedStyle.borderColor,
        },
      ]}
    >
      <TouchableOpacity
        style={styles.infoBoxHeader}
        onPress={() => setIsOpen(!isOpen)}
        disabled={!collapsible}
      >
        {selectedStyle.icon}
        {typeof title === "string" ? (
          <Text style={styles.infoBoxHeaderContent}>{title}</Text>
        ) : (
          <View style={styles.infoBoxHeaderContent}>{title}</View>
        )}

        {collapsible && (
          <AccordeonArrow style={styles.infoBoxArrow} rotate={isOpen} />
        )}
      </TouchableOpacity>

      {(!collapsible || isOpen) && children && (
        <View style={styles.infoBoxContent}>{children}</View>
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  infoBoxContainer: {
    width: "100%",
    borderWidth: 1,
    borderRadius: 12,
    marginBottom: 24,
  },
  infoBoxHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 20,
  },
  infoBoxHeaderContent: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingLeft: Spacing.S,
    fontWeight: "bold",
  },
  infoBoxArrow: {
    fontSize: 14,
    color: Colors.gray1,
    marginLeft: 12,
  },
  infoBoxContent: {
    paddingHorizontal: 20,
    paddingBottom: 20,
  },
})
